<template>
  <div class="bottom">
    <div class="bottom-wid1">
      <div class="left">
        <div class="contactTitle">商务合作</div>
        <div class="contactWay contactMargin2">
          <div class="name">全国服务热线:</div>
          <div class="contact">023-62320810</div>
        </div>
        <div class="contactWay contactMargin2">
          <div class="name">邮箱:</div>
          <div class="contact">13883853595@aliyun.com</div>
        </div>
        <div class="contactWay contactMargin2">
          <div class="name">公司名称:</div>
          <div class="contact">重庆太扬翔药业有限公司</div>
        </div>
        <div class="contactWay contactMargin2">
          <div class="name">地址:</div>
          <div class="contact">重庆市经开区长生桥镇玉马路8号D栋一楼</div>
        </div>
      </div>
      <div class="right">
        <img :src="require('@/assets/ewm-12787591.jpg')" alt="" />
        <div class="name">微信扫一扫</div>
      </div>
    </div>
    <div class="bottom-wid2">渝ICP备2023007042号-1 ©重庆太扬翔药业有限公司</div>
  </div>
</template>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}

.bottom {
  background-color: rgb(19, 20, 24);
  margin-top: 10px;
  position: relative;

  .bottom-wid1 {
    width: 80%;
    margin: 0 auto;
    padding: 50px 0 10px;

    .left {
      width: 100%;
      height: auto;

      .contactTitle {
        font-size: 16px;
        color: #fff;
        text-align: left;
        margin-bottom: 10px;
      }

      .contactWay {
        display: flex;
        justify-content: left;
        align-items: center;
        font-size: 12px;

        .name {
          margin-right: 10px;
          opacity: 0.5;
          color: #fff;
        }
        .contact {
          margin-right: 60px;
          color: #fff;
        }
      }

      .contactMargin2 {
        margin: 0 0 10px 0;
      }
    }

    .right {
      width: 80px;
      position: absolute;
      top: 10px;
      right: 10px;

      img {
        width: 100%;
      }

      .name {
        margin-top: 15px;
        font-size: 12px;
        color: #bfc2c8;
        text-align: center;
      }
    }
  }

  .bottom-wid2 {
    width: 100%;
    height: 64px;
    background-color: black;
    font-size: 10px;
    text-align: center;
    line-height: 64px;
    color: #bfc2c8;
  }
}
</style>
